import React from 'react';
import './Skeleton.scss';

const Skeleton = ({ 
  width, 
  height, 
  borderRadius = '4px', 
  className = '',
  variant = 'rectangular' 
}) => {
  const skeletonClasses = [
    'skeleton',
    `skeleton--${variant}`,
    className
  ].filter(Boolean).join(' ');

  const style = {
    width,
    height,
    borderRadius
  };

  return <div className={skeletonClasses} style={style} />;
};

export default Skeleton;